module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/placement.540e67d3.svg";